import { PageLayout } from '@src/common/PageLayout';
import { styled } from '@uhg-abyss/web/tools/styled';
import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { config } from '@uhg-abyss/web/tools/config';
import { Link } from '@uhg-abyss/web/ui/Link';
import { event } from '@uhg-abyss/web/tools/event';

const MarginStyle = styled('div', {
  margin: '10px 10px 10px 0.825rem',
});

const TextStyleBold = styled('div', {
  fontWeight: 'bold',
});

export const LearnAbout = () => {
  const handleUhcProviderClick = () => {
    event('VISIT_UHC_PROVIDER');
  };

  return (
    <PageLayout style={{ height: '100%' }}>
      <Card header="Learn about the UnitedHealthcare Provider Portal">
        <MarginStyle>
          <p id="learn-about-desc">
            UnitedHealthcare's suite of online healthcare tools, news and
            resources are designed to support you as you deliver care for your
            patients, every step of the way.
          </p>
          <p />
          <TextStyleBold>
            <Link
              id="learn-about-uhcprovider"
              href={config('UHC_LEARN_ABOUT')}
              onClick={handleUhcProviderClick}
            >
              Visit uhcprovider.com
            </Link>
          </TextStyleBold>
        </MarginStyle>
      </Card>
    </PageLayout>
  );
};
